import { NgModule } from '@angular/core';
import { LoadingContentDirective } from './loading-content.directive';

@NgModule({
  declarations: [LoadingContentDirective],
  exports: [LoadingContentDirective]
})
export class LoadingContentModule { }
